import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-gravatar',
  templateUrl: './gravatar.component.html',
  styleUrls: ['./gravatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GravatarComponent implements OnInit {
  @Input() isNotificationOn: boolean;
  @Input() isStacked: boolean = true;
  @Input() acronymText: string;

  public randomBorderColor: string;

  constructor() {}

  ngOnInit(): void {
    const borderColorOptions = [
      '--primary-purple',
      '--secondary-purple',
      '--purple',
      '--secondary-turquoise',
      '--dark-turquoise',
      '--blue2',
      '--blue3',
    ];
    const randomColorOption = Math.floor(Math.random() * borderColorOptions.length);
    this.randomBorderColor = getComputedStyle(document.documentElement).getPropertyValue(borderColorOptions[randomColorOption]);
  }
}
